'use client';

import Footer from '@/src/components/ui/Footer';
import { useSrpViewMode } from './ViewModeContext';

export function SrpPageFooter() {
  const { viewMode } = useSrpViewMode();

  if (viewMode === 'feed') return null;

  return (
    <div id="srp-footer" data-srp-component="footer">
      <Footer showCrossbrand={false} />
    </div>
  );
}
